import { createCouponDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useCouponDetailsQuery = createCouponDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
